import { Typography, Collapse } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './style.module.css';

const { Title, Text } = Typography;

const Faq: React.FC = () => {
  const { t } = useTranslation();

  const faqItems = [
    { questionKey: 'faq.q1', answerKey: 'faq.a1' },
    { questionKey: 'faq.q2', answerKey: 'faq.a2' },
    { questionKey: 'faq.q3', answerKey: 'faq.a3' },
    { questionKey: 'faq.q4', answerKey: 'faq.a4' },
    { questionKey: 'faq.q5', answerKey: 'faq.a5' },
    { questionKey: 'faq.q6', answerKey: 'faq.a6' },
    { questionKey: 'faq.q7', answerKey: 'faq.a7' },
    { questionKey: 'faq.q8', answerKey: 'faq.a8' },
    { questionKey: 'faq.q9', answerKey: 'faq.a9' },
    { questionKey: 'faq.q10', answerKey: 'faq.a10' },
    { questionKey: 'faq.q11', answerKey: 'faq.a11' },
  ];

  return (
    <div className={styles.outer}>
      <div className={styles.wrapper}>
        <Title level={2} className={styles.title}>
          {t('faq.title')}
        </Title>

        <Collapse
          accordion
          className={styles.collapse}
          bordered={false}
          expandIconPosition="end"
          items={faqItems.map((item, index) => ({
            key: String(index),
            className: styles.panel,
            forceRender: true,
            label: (
              <Text strong className={styles.question}>
                {t(item.questionKey)}
              </Text>
            ),
            children: <Text className={styles.text}>{t(item.answerKey)}</Text>,
          }))}
        />
      </div>
    </div>
  );
};

export default Faq;
